import { render, staticRenderFns } from "./TurnOn.vue?vue&type=template&id=20bec2ed"
import script from "./TurnOn.vue?vue&type=script&lang=js"
export * from "./TurnOn.vue?vue&type=script&lang=js"
import style0 from "./TurnOn.vue?vue&type=style&index=0&id=20bec2ed&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports